import { create } from 'zustand';

interface UpgradeDialogState {
  isOpen: boolean;
  feature: string | null; // 'extras' | 'bookkeeping' | 'students' | null — the row to highlight
  open: (feature?: string) => void;
  close: () => void;
}

export const useUpgradeDialogStore = create<UpgradeDialogState>((set) => ({
  isOpen: false,
  feature: null,
  open: (feature) => set({ isOpen: true, feature: feature ?? null }),
  close: () => set({ isOpen: false, feature: null }),
}));
